<template>
  <div>
    <Banner :list="banner"></Banner>
    <Product :list="product" :cases="cases"></Product>
    <About :about="about"></About>
    <Solution :list="solution"></Solution>
    <section class="news_section">
      <div class="container">
        <!-- 标题 -->
        <div class="home_title">
          <div class="left">
            <h1><i>H</i>AIMA NEWS</h1>
            <!-- <p>海玛智能·新闻中心</p> -->
          </div>
          <router-link class="more iconfont icon-jiantou b" :to="{ path: '/news' }">MORE</router-link>
        </div>
        <News :list="news"></News>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from "@/components/home/banner.vue";
import Product from "@/components/home/product.vue";
import About from "@/components/home/about.vue";
import Solution from "@/components/home/solution.vue";
import News from "@/components/home/news.vue";
import service from "@/assets/js/service";

export default {
  name: "Home",
  components: { Banner, Product, About, Solution, News },
  data() {
    return {
      banner: [],
      cases: [],
      news: [],
      product: [],
      solution: [{ id: 0 }],
      about: {},
    };
  },
  mounted() {
    this.index();
    this.aboutIndex();
  },
  methods: {
    async index() {
      let res = await service.homeIndex();
      if (res.code != 1) return;

      this.banner = res.data.bannerlist;
      this.cases = res.data.caselist;
      this.news = res.data.news;
      this.product = res.data.productlist;
      this.solution = res.data.solutionlist;
    },

    async aboutIndex() {
      let res = await service.aboutIndex();
      if (res.code != 1) return;
      this.about = res.data.aboutinfo;
    },
  },
};
</script>
<style lang="less">
.news_section {
  margin: -100px 0 0;
  padding: 100px 0;
  background: #f3f7fc;
}

.home_title {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 50px;

  .left {
    h1 {
      font-size: 50px;
      line-height: 1.1;

      i {
        color: var(--themeColor2);
      }
    }

    p {
      font-size: 26px;
      line-height: 1;
      margin-top: 10px;
    }
  }
}

@media (max-width: 700px) {
  .news_section {
    padding: 40px 0;
  }

  .home_title {
    margin-bottom: 20px;

    .left {
      h1 {
        font-size: 30px;
      }

      p {
        font-size: 16px;
      }
    }
  }
}
</style>
